import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon, CalendarIcon, MapPinIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { useApp } from '../context/AppContext';
export const ScheduleSuccess: React.FC = () => {
  const navigate = useNavigate();
  const {
    currentRide
  } = useApp();
  return <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6" data-id="element-613">
      <div className="w-full max-w-md" data-id="element-614">
        <div className="flex flex-col items-center mb-8" data-id="element-615">
          <div className="w-20 h-20 bg-primary bg-opacity-20 rounded-full flex items-center justify-center mb-4" data-id="element-616">
            <CheckCircleIcon size={48} className="text-primary" data-id="element-617" />
          </div>
          <h1 className="text-2xl font-bold mb-2" data-id="element-618">Ride Scheduled!</h1>
          <p className="text-white text-opacity-70 text-center" data-id="element-619">
            Your ride has been successfully scheduled
          </p>
        </div>
        <div className="card mb-6" data-id="element-620">
          <div className="flex items-center mb-4" data-id="element-621">
            <CalendarIcon size={20} className="text-primary mr-3" data-id="element-622" />
            <div data-id="element-623">
              <p className="text-sm text-white text-opacity-70" data-id="element-624">
                Scheduled for
              </p>
              <p className="font-medium" data-id="element-625">
                {currentRide.date?.toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })}
              </p>
              <p className="text-primary" data-id="element-626">
                {currentRide.date?.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit'
              })}
              </p>
            </div>
          </div>
          <div className="border-t border-white border-opacity-10 my-4" data-id="element-627"></div>
          <div className="flex items-start mb-3" data-id="element-628">
            <MapPinIcon size={18} className="text-primary mt-1 mr-3" data-id="element-629" />
            <div data-id="element-630">
              <p className="text-sm text-white text-opacity-70" data-id="element-631">From</p>
              <p className="font-medium" data-id="element-632">{currentRide.pickup?.name}</p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-633">
            <MapPinIcon size={18} className="text-primary mt-1 mr-3" data-id="element-634" />
            <div data-id="element-635">
              <p className="text-sm text-white text-opacity-70" data-id="element-636">To</p>
              <p className="font-medium" data-id="element-637">{currentRide.dropoff?.name}</p>
            </div>
          </div>
          <div className="border-t border-white border-opacity-10 my-4" data-id="element-638"></div>
          <div className="flex items-center justify-between" data-id="element-639">
            <div data-id="element-640">
              <p className="text-sm text-white text-opacity-70" data-id="element-641">Ride Type</p>
              <p className="font-medium" data-id="element-642">{currentRide.type}</p>
            </div>
            <div className="chip" data-id="element-643">
              {currentRide.currency} {currentRide.price}
            </div>
          </div>
        </div>
        <div className="bg-card border border-primary border-opacity-30 rounded-lg p-4 mb-6" data-id="element-644">
          <p className="text-sm text-white text-opacity-70" data-id="element-645">
            We'll send you a notification when your driver is assigned. You can
            track your scheduled rides in the Bookings tab.
          </p>
        </div>
        <div className="space-y-3" data-id="element-646">
          <Button onClick={() => navigate('/bookings')} data-id="element-647">
            View My Bookings
          </Button>
          <Button variant="secondary" onClick={() => navigate('/')} data-id="element-648">
            Back to Home
          </Button>
        </div>
      </div>
    </div>;
};